// src/components/page-content-v4/PageFormMain.tsx
import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { PageFormProvider, usePageFormContext } from './contexts/PageFormContext';
import PageForm from './modules/PageForm';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import toast from 'react-hot-toast';

const PageFormContent: React.FC = () => {
  const { template, page, setPage, isLoading, error, savePage, isSeoEnabled, accountInfo, isDraftEditing, handlePublishDraft, reloadPageData, discardDraft } = usePageFormContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedLanguage = searchParams.get('cl') || 'en';

  if (isLoading) return <LoadingSpinner />;
  if (error) return <div>Error loading page data.</div>;
  if (!template || !page) return <div>Template or Page data not found.</div>;

  const handleSave = async (isDraft: boolean) => {
    try {
      await savePage(isDraft);
      const languageParam = selectedLanguage ? `?cl=${selectedLanguage}` : '';
      page.isSinglePage ? navigate(`/content-library`) :  navigate(`/page-content/${template.templateId}${languageParam}`);
    } catch (error) {
      // Handle save error
      toast.error('Error saving page');
    }
  };

  return (
    <PageForm
      templateId={template.templateId}
      template={template}
      page={page}
      setPage={setPage}
      onSave={handleSave}
      isSeoEnabled={isSeoEnabled}
      selectedLanguage={selectedLanguage}
      accountInfo={accountInfo || {}}
      isDraftEditing={isDraftEditing}
      handlePublishDraft={handlePublishDraft}
      reloadPageData={reloadPageData}
      discardDraft={discardDraft}
    />
  );
};

const PageFormPage: React.FC = () => {
  const { templateId, pageId } = useParams<{ templateId: string; pageId?: string }>();
  const [searchParams] = useSearchParams();
  const selectedLanguage = searchParams.get('cl') || 'en';

  return (
    <PageFormProvider templateId={templateId!} pageId={pageId} selectedLanguage={selectedLanguage}>
      <PageFormContent />
    </PageFormProvider>
  );
};

export default PageFormPage;
